import './index.css';
import React from 'react';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'D2D HIRE';
render(<App data-id="element-1758" data-mp="1wc5wg7wxayme" />, document.getElementById('root'));